import React  from 'react';
import PropTypes from "prop-types";
import Loading from "Components/Common/Loading";

//redux
import { useSelector } from "react-redux";
import withRouter from '../Components/Common/bootstrap/withRouter';
import { CpmAuth } from 'script/cpmAuth';

const Fullscreen = (props) => {
    const {loading} = useSelector(state => state.Loading)
    return (
        <React.Fragment>
            {props.children}
            <CpmAuth/>
            {loading && <Loading/>}
        </React.Fragment>
    );
};
Fullscreen.propTypes = {
    children: PropTypes.any,
};

export default withRouter(Fullscreen);
